import PropTypes from 'prop-types';
import { useEffect } from 'react';

import log from 'client/lib/log';
import getLinkToken from 'client/actions/Plaid/getLinkToken';
import useBranch from 'client/hooks/useBranch';
import useDispatch from 'client/hooks/useDispatch';

const debug = log.debug('sunroom:components:SrWithPlaidLinkToken');

const SrWithPlaidLinkToken = ({ userId, accessToken, children }) => {
  debug({ userId, accessToken });
  const { plaidLinkToken } = useBranch({
    plaidLinkToken: ['plaidLinkToken'],
  });
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getLinkToken, {
      userId,
      accessToken,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId, accessToken]);

  if (!plaidLinkToken) {
    return null;
  }
  return children({ plaidLinkToken });
};

SrWithPlaidLinkToken.propTypes = {
  accessToken: PropTypes.string.isRequired,
  userId: PropTypes.number.isRequired,
  children: PropTypes.func.isRequired,
};

SrWithPlaidLinkToken.displayName = 'SrWithPlaidLinkToken';

export default SrWithPlaidLinkToken;
